import React from 'react';

export const PlayCircleIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="40" cy="40" r="40" fill="black" fillOpacity="0.4" />
    <circle cx="40" cy="40" r="38" stroke="white" strokeOpacity="0.6" strokeWidth="2" />
    <path
      d="M55 40L32.5 53.0156V26.9844L55 40Z"
      fill="white"
      style={{ filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}
    />
  </svg>
);